const antDTheme = {
  token: {
    colorPrimary: '#038767',
  },
};

export default antDTheme;
